import React, { useState } from "react";

import EpisodeDetails from "./EpisodeDetails";
import { Episode } from "../types";
import { avatarUrl, characterIds } from "../utils/rickAndMorty";

const EpisodeCard: React.FC<{ episode: Episode }> = ({ episode }) => {
  const [isOpen, setIsOpen] = useState(false);
  // The episode payload already carries character urls, so the collage costs
  // nothing extra — the avatar path is derived from the id.
  const previewIds = characterIds(episode.characters, 4);

  return (
    <article className="group flex flex-col overflow-hidden rounded-xl border border-white/10 bg-space-800 transition hover:-translate-y-0.5 hover:border-portal-400/50 hover:shadow-xl hover:shadow-black/40">
      {/* Fixed rows: without them each avatar keeps its intrinsic height and
          the collage spills over the card. */}
      <div className="grid h-40 grid-cols-2 grid-rows-2 gap-px overflow-hidden bg-white/5">
        {previewIds.map((id) => (
          <img
            key={id}
            src={avatarUrl(id)}
            alt=""
            loading="lazy"
            className="h-full w-full min-h-0 object-cover"
          />
        ))}
      </div>

      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-start justify-between gap-3">
          <h3 className="font-semibold leading-snug text-white">
            {episode.name}
          </h3>
          <span className="shrink-0 rounded-md bg-portal-400/15 px-2 py-1 text-xs font-medium text-portal-400">
            {episode.episode}
          </span>
        </div>

        <p className="mt-2 text-sm text-slate-400">{episode.air_date}</p>
        <p className="text-sm text-slate-400">
          {episode.characters.length} characters
        </p>

        <button
          type="button"
          onClick={() => setIsOpen(true)}
          className="mt-4 rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm font-medium text-white transition hover:border-portal-400/60 hover:bg-portal-400/10"
        >
          View details
        </button>
      </div>

      <EpisodeDetails
        episode={episode}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </article>
  );
};

const EpisodeList: React.FC<{ episodes: Episode[] }> = ({ episodes }) => {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {episodes.map((episode) => (
        <EpisodeCard key={episode.id} episode={episode} />
      ))}
    </div>
  );
};

export default EpisodeList;
